import { endOfDay, endOfMonth, startOfDay, startOfMonth } from 'date-fns'
import { findPromocodeHistoryData_findPromocodeHistoryGraph } from '__generatedTypes__/findPromocodeHistoryData'
import { DateOption, DateOptionsEnum, Filters } from '../consts'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const getDaysForRange = (from: Date, to: Date) => {
  const days = []
  const current = startOfDay(from)
  const endTime = endOfDay(to).getTime()
  while (current.getTime() <= endTime) {
    days.push(String(current.getDate()))
    current.setDate(current.getDate() + 1)
  }

  return days
}

const getMonthsForRange = (from: Date, to: Date) => {
  const months = []
  const current = startOfMonth(from)
  const endTime = endOfMonth(to).getTime()

  while (current.getTime() <= endTime) {
    months.push(MONTHS[current.getMonth()])
    current.setMonth(current.getMonth() + 1)
  }

  return months
}

export const getDays = (filters: Filters) => getDaysForRange(filters.from, filters.to)

export const getMonths = (filters: Filters, selectedDate: DateOption) => {
  if (selectedDate.id === DateOptionsEnum.Lifetime) {
    return MONTHS
  }

  return getMonthsForRange(filters.from, filters.to)
}

export const mapDaysData = (data: findPromocodeHistoryData_findPromocodeHistoryGraph[], xAxis: string[]) =>
  xAxis.map((item) => {
    const found = data.find(({ date: dateStr }) => {
      const date = new Date(dateStr + 'T00:00:00.000')
      return date.getDate() === Number(item)
    })

    return found || null
  })

export const mapMonthData = (
  data: findPromocodeHistoryData_findPromocodeHistoryGraph[],
  xAxis: string[],
  year: number
) => {
  const _data = data.filter((item) => {
    const date = new Date(item.date + '-01T00:00:00.000')
    return date.getFullYear() === year
  })

  return xAxis.map((item) => {
    const month = MONTHS.indexOf(item)
    const found = _data.find((item) => {
      const date = new Date(item.date + '-01T00:00:00.000')
      return date.getMonth() === month
    })

    return found || null
  })
}
